import OrganizationAPI from "~/common/apis/OrganizationAPI";

export const getUsersList = async (
  orgId,
  page,
  pageSize,
  fields,
  roles,
  cancelToken
) => {
  try {
    const response = await OrganizationAPI.listUsers(
      orgId,
      page,
      pageSize,
      fields,
      roles,
      cancelToken
    );
    if (response.data.length) return response.data;
  } catch (error) {
    console.error("Fetch shifts error:", error);
  }
};

export const getBaseOrganization = async orgId => {
  try {
    const httpResult = await OrganizationAPI.getBaseOrganization(orgId);

    localStorage.setItem("kcc/base_org", httpResult.data);

    return httpResult.data;
  } catch (error) {
    console.error(error);
  }
};
